export { default as DiscoveryTerritoryLayer } from './DiscoveryTerritoryLayer';
